import { FinanceOptionsSection } from "@/components/finance-options-section";
import { financingLp } from "@/content/landing/financing";

export interface SolarFinanceEligibilityProps {
  sourcePage?: string;
  bodyCopy?: string;
  serviceLabel?: string;
}

export function SolarFinanceEligibility({
  sourcePage = "/financing",
  bodyCopy = financingLp.heroSub,
  serviceLabel = "Financing",
}: SolarFinanceEligibilityProps) {
  return (
    <FinanceOptionsSection
      sourcePage={sourcePage}
      serviceLabel={serviceLabel}
      eyebrow="£ Finance"
      headline={
        <>
          Finance Options:{" "}
          <br />
          <span className="font-normal">Spread The Cost</span>
        </>
      }
      intro={bodyCopy}
    />
  );
}
